import { useEffect, useState } from 'react'

export const getFilterDropdownBoundaryStyle = (boundary, trigger, header) => {
  const inset = 8
  const width = Math.min(360, Math.max(0, boundary.width - inset * 2))
  const left = Math.min(
    Math.max(trigger.left, boundary.left + inset),
    boundary.right - inset - width
  )
  const minimumTop = Math.max(
    boundary.top + inset,
    header?.bottom || boundary.top
  )
  const bottom = boundary.bottom - inset
  const height = Math.min(480, Math.max(0, bottom - minimumTop))
  const top = Math.max(
    minimumTop,
    Math.min(trigger.bottom + 4, bottom - height)
  )
  return {
    position: 'fixed',
    top: Math.round(top),
    left: Math.round(left),
    width: Math.round(width),
    height: Math.round(height)
  }
}

const useFilterDropdownBoundary = (opened, componentRef, boundaryRef) => {
  const [style, setStyle] = useState(null)
  useEffect(() => {
    if (!opened || !boundaryRef) {
      setStyle(null)
      return undefined
    }
    const boundary = boundaryRef.current
    const trigger = componentRef.current?.firstElementChild
    if (!boundary || !trigger) return undefined
    const update = () =>
      setStyle(
        getFilterDropdownBoundaryStyle(
          boundary.getBoundingClientRect(),
          trigger.getBoundingClientRect(),
          boundary.firstElementChild?.getBoundingClientRect()
        )
      )
    update()
    const observer =
      typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(update)
    observer?.observe(boundary)
    observer?.observe(trigger)
    window.addEventListener('resize', update)
    window.addEventListener('scroll', update, true)
    return () => {
      observer?.disconnect()
      window.removeEventListener('resize', update)
      window.removeEventListener('scroll', update, true)
    }
  }, [opened, componentRef, boundaryRef])
  return boundaryRef ? style || { visibility: 'hidden' } : undefined
}

export default useFilterDropdownBoundary
